import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { RANKING_LEVELS, RANKING_COLORS } from "./ProfessorConstants";

// Ranking Dialog Component
export const RankingDialog = ({ 
  isOpen, 
  onOpenChange, 
  selectedStudent, 
  rankingSurf, 
  rankingBodyboard, 
  onUpdateRanking 
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Rankings - {selectedStudent?.name}</DialogTitle>
          <DialogDescription>Atribui o nivel de ranking do aluno em Surf e/ou Bodyboard</DialogDescription>
        </DialogHeader>
        <div className="space-y-6">
          <div>
            <Label className="text-base font-semibold text-[#3d5a63] mb-3 block">Surf</Label>
            <div className="flex flex-wrap gap-2">
              <Button 
                size="sm" 
                variant={!rankingSurf ? "default" : "outline"} 
                className={!rankingSurf ? "bg-[#94A3B8]" : ""} 
                onClick={() => onUpdateRanking("surf", "")} 
                data-testid="prof-ranking-surf-none"
              >
                Sem ranking
              </Button>
              {RANKING_LEVELS.map((level) => (
                <Button 
                  key={level} 
                  size="sm" 
                  variant={rankingSurf === level ? "default" : "outline"} 
                  onClick={() => onUpdateRanking("surf", level)} 
                  data-testid={`prof-ranking-surf-${level.toLowerCase()}`}
                >
                  <span className={`w-3 h-3 rounded-full mr-1.5 border ${RANKING_COLORS[level]}`}></span>
                  {level}
                </Button>
              ))}
            </div>
            {rankingSurf && <p className="text-sm text-[#6697a4] mt-2">Nivel atual: <strong>{rankingSurf}</strong></p>}
          </div>
          <div>
            <Label className="text-base font-semibold text-[#3d5a63] mb-3 block">Bodyboard</Label>
            <div className="flex flex-wrap gap-2">
              <Button 
                size="sm" 
                variant={!rankingBodyboard ? "default" : "outline"} 
                className={!rankingBodyboard ? "bg-[#94A3B8]" : ""} 
                onClick={() => onUpdateRanking("bodyboard", "")} 
                data-testid="prof-ranking-bb-none"
              >
                Sem ranking
              </Button>
              {RANKING_LEVELS.map((level) => (
                <Button 
                  key={level} 
                  size="sm" 
                  variant={rankingBodyboard === level ? "default" : "outline"} 
                  onClick={() => onUpdateRanking("bodyboard", level)} 
                  data-testid={`prof-ranking-bb-${level.toLowerCase()}`}
                >
                  <span className={`w-3 h-3 rounded-full mr-1.5 border ${RANKING_COLORS[level]}`}></span>
                  {level}
                </Button>
              ))}
            </div>
            {rankingBodyboard && <p className="text-sm text-[#6697a4] mt-2">Nivel atual: <strong>{rankingBodyboard}</strong></p>}
          </div>
        </div>
        <DialogFooter>
          <DialogClose asChild><Button variant="outline">Fechar</Button></DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
